export default function modifySiteModerators({ commit }, { field, value }) {
  commit("MODIFY_SITE_MODERATORS", { field, value });

  return Promise.resolve();
}
